import React, { useState } from "react";
import { useDispatch, useSelector } from "react-redux";
import NoRecord from "../../../components/other/NoRecord";
import {
  deleteAddress,
  fetchAddresses,
} from "../../../redux/action/authAction";

const AddressList = () => {
  const dispatch = useDispatch();
  const { addressList } = useSelector((state) => state.authReducer);
  const [addressId, setAddressId] = useState({});

  const handleDeleteAddress = () => {
    const callback = (response) => {
      if (response.success);
      dispatch(fetchAddresses());
    };
    dispatch(
      deleteAddress({
        payload: { address_id: addressId },
        callback,
      })
    );
  };

  return (
    <>
      <div class="col-md-8 offset-md-1 mb-4">
        <div class="ct_my_account_right">
          <p>
            The following addresses will be used on the checkout page by
            default.
          </p>

          <div class="row">
            {addressList && addressList?.length > 0 ? (
              addressList?.map((address) => (
                <div className="col-md-5" key={address?.id}>
                  <div className="ct_address_card">
                    <div
                      className="ct_addess_delete_icon"
                      data-bs-toggle="modal"
                      data-bs-target="#ct_delete_address"
                      // class="btn btn-black btn-sm"
                      onClick={() => setAddressId(address?.id)}
                    >
                      {" "}
                      <i
                        class="fa fa-trash"
                        aria-hidden="true"
                        onClick={() => {}}
                      />
                    </div>
                    <i className="fa-solid fa-map-location-dot"></i>
                    <h4>Billing Address</h4>
                    <p className="mb-0">
                      {address?.address_line_1}, {address?.city || ""}{" "}
                      {address?.state}, {address?.country}
                      <br />
                      {address?.postal_code}
                    </p>
                    <p className="mb-0">
                      <strong>Phone:</strong> {address?.number}
                    </p>
                  </div>
                </div>
              ))
            ) : (
              <NoRecord />
            )}
          </div>
        </div>
      </div>

      {/* Model */}
      <div
        className="modal fade ct_assets_modal"
        id="ct_delete_address"
        tabIndex="-1"
        aria-labelledby="ct_logout_modalLabel"
        aria-hidden="true"
      >
        <div className="modal-dialog modal-dialog-centered">
          <div className="modal-content">
            <div className="modal-header border-0 pt-0">
              <button
                type="button"
                className="btn-close ct_cloose_btn"
                data-bs-dismiss="modal"
                aria-label="Close"
              >
                <i className="fa-solid fa-xmark"></i>
              </button>
            </div>
            <div className="modal-body border-0 ">
              <div className="text-center mb-3">
                <svg
                  xmlns="http://www.w3.org/2000/svg"
                  width="24px"
                  viewBox="0 0 448 512"
                >
                  <path
                    d="M170.5 51.6L151.5 80l145 0-19-28.4c-1.5-2.2-4-3.6-6.7-3.6l-93.7 0c-2.7 0-5.2 1.3-6.7 3.6zm147-26.6L354.2 80 368 80l48 0 8 0c13.3 0 24 10.7 24 24s-10.7 24-24 24l-8 0 0 304c0 44.2-35.8 80-80 80l-224 0c-44.2 0-80-35.8-80-80l0-304-8 0c-13.3 0-24-10.7-24-24S10.7 80 24 80l8 0 48 0 13.8 0 36.7-55.1C140.9 9.4 158.4 0 177.1 0l93.7 0c18.7 0 36.2 9.4 46.6 24.9zM80 128l0 304c0 17.7 14.3 32 32 32l224 0c17.7 0 32-14.3 32-32l0-304L80 128zm80 64l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16zm80 0l0 208c0 8.8-7.2 16-16 16s-16-7.2-16-16l0-208c0-8.8 7.2-16 16-16s16 7.2 16 16z"
                    fill="#bb0000"
                  />
                </svg>
              </div>
              <h4 className="text-center mb-2 ct_fw_600">Remove Address</h4>
              <p className="text-center ct_grey_text">
                Are you sure you want to remove this address?
              </p>
              <div className="modal-footer border-0 justify-content-center">
                <button
                  type="button"
                  className="ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <a
                  onClick={() => {
                    handleDeleteAddress();
                  }}
                  href="javascript:void(0)"
                  type="button"
                  data-bs-dismiss="modal"
                  className="bg-danger ct_single_cart_btn ct_btn_animate ghost ct_black_animation_btn"
                  style={{ borderColor: "rgb(220, 53, 69)" }}
                >
                  Confirm
                </a>
              </div>
              <div></div>
            </div>
          </div>
        </div>
      </div>
    </>
  );
};

export default AddressList;
